import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import {
  ACCESS_DENIED_EVENT,
} from "../utils/accessDenied";
import "../assets/styles/permissionpopup.css";

const AccessDeniedDialog = () => {
  const navigate = useNavigate();

  const [visible, setVisible] = useState(false);
  const [details, setDetails] = useState({
    message:
      "You do not have permission to perform this action.",
    pageName: null,
    action: null,
  });

  useEffect(() => {
    const handleAccessDenied = (event) => {
      setDetails({
        message:
          event.detail?.message ||
          "You do not have permission to perform this action.",
        pageName:
          event.detail?.pageName || null,
        action:
          event.detail?.action || null,
      });

      setVisible(true);
    };

    window.addEventListener(
      ACCESS_DENIED_EVENT,
      handleAccessDenied
    );

    return () => {
      window.removeEventListener(
        ACCESS_DENIED_EVENT,
        handleAccessDenied
      );
    };
  }, []);

  const goBack = () => {
    setVisible(false);

    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/ProfileDash", {
        replace: true,
      });
    }
  };

  const goToDashboard = () => {
    setVisible(false);

    navigate("/ProfileDash", {
      replace: true,
    });
  };

  const footer = (
    <div className="access-denied-footer">
      <Button
        label="Go Back"
        icon="pi pi-arrow-left"
        severity="secondary"
        outlined
        onClick={goBack}
      />

      <Button
        label="Dashboard"
        icon="pi pi-home"
        onClick={goToDashboard}
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      modal
      closable={false}
      closeOnEscape={false}
      dismissableMask={false}
      draggable={false}
      resizable={false}
      onHide={() => { }}
      header="Access Restricted"
      footer={footer}
      className="access-denied-dialog"
    >
      <div className="access-denied-content">
        <div className="access-denied-icon">
          <i className="pi pi-lock" />
        </div>

        <div>
          <h3>You are not authorised</h3>

          <p>{details.message}</p>

          {(details.pageName ||
            details.action) && (
              <div className="access-denied-meta">
                {details.pageName && (
                  <span>
                    Page:{" "}
                    <strong>
                      {details.pageName}
                    </strong>
                  </span>
                )}

                {details.action && (
                  <span>
                    Action:{" "}
                    <strong>
                      {details.action}
                    </strong>
                  </span>
                )}
              </div>
            )}
        </div>
      </div>
    </Dialog>
  );
};

export default AccessDeniedDialog;